export enum ReportsTypes {
  REPORTS_REQUEST = 'userData/Reports/REPORTS_REQUEST',
  REPORTS_SUCCESS = 'userData/Reports/REPORTS_SUCCESS',
  REPORTS_FAILURE = 'userData/Reports/REPORTS_FAILURE',
  SET_DISPLAY_REPORTS = 'userData/Reports/SET_DISPLAY_REPORTS',
  SELECT_REPORT = 'userData/Reports/SELECT_REPORT',
  REPORT_REQUEST = 'userData/Reports/REPORT_REQUEST',
  REPORT_SUCCESS = 'userData/Reports/REPORT_SUCCESS',
  REPORT_FAILURE = 'userData/Reports/REPORT_FAILURE',
  REGENERATE_REPORT_REQUEST = 'userData/Reports/REGENERATE_REPORT_REQUEST',
  REGENERATE_REPORT_SUCCESS = 'userData/Reports/REGENERATE_REPORT_SUCCESS',
  REGENERATE_REPORT_FAILURE = 'userData/Reports/REGENERATE_REPORT_FAILURE',
}
